import React, { useState } from 'react';
import styles from '../../Payyitme.module.css';

const faqData = [
  {
    q: 'What is a Fyntiq.Me Lynk?',
    a: 'A personal payment link at fyntiq.me/yourname. Anyone with the link can send you money securely — no account required for them to pay.',
  },
  {
    q: 'Is it free to create?',
    a: 'Yes. Creating and sharing your Lynk is free. Standard processing fees apply when you receive payments, same as other Fyntiq payment methods.',
  },
  {
    q: 'Can I use it for my business?',
    a: 'Absolutely. Many freelancers and small businesses use their Lynk for quick payments, tips, and deposits. Business accounts can also access chargeback protection on eligible card payments.',
  },
  {
    q: 'How do people pay me?',
    a: 'They open your link, enter an amount, and pay with Fyntiq Wallet, card, or bank transfer — whichever they prefer.',
  },
];

const Faq = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className={styles.sec} style={{ paddingTop: 0 }}>
      <div className={`${styles.container} ${styles.faqGrid}`}>
        <div className={`${styles.secHead} ${styles.sr}`} data-sr style={{ margin: 0 }}>
          <span className={styles.eyebrow}><span className={styles.dot} />FAQ</span>
          <h2 style={{ fontSize: 38 }}>Lynk questions.</h2>
        </div>
        <div className={styles.sr} data-sr>
          {faqData.map((item, i) => (
            <div key={item.q} className={`${styles.faqItem} ${openIndex === i ? styles.faqItemOpen : ''}`}>
              <div
                className={styles.faqQ}
                onClick={() => setOpenIndex(openIndex === i ? -1 : i)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => e.key === 'Enter' && setOpenIndex(openIndex === i ? -1 : i)}
              >
                {item.q} <span className={styles.pm}>+</span>
              </div>
              <div className={styles.faqA}><p>{item.a}</p></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Faq;
